import { gql } from '@apollo/client'

export default gql(`
    query($fileName: String! $contentType: String! $type: String!) {
        getMultipartUploadId(input: {
            type: $type
            fileName: $fileName
            contentType: $contentType
        } )
        {
            fileKey
            uploadId
        }
    }
    `
)
